import { render, staticRenderFns } from "./bym_Aumento.vue?vue&type=template&id=0404653b&scoped=true"
import script from "./bym_Aumento.vue?vue&type=script&lang=js"
export * from "./bym_Aumento.vue?vue&type=script&lang=js"
import style0 from "./bym_Aumento.vue?vue&type=style&index=0&id=0404653b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0404653b",
  null
  
)

export default component.exports